import { Box, Grid } from "@mui/material"
import MenuTab from "../../../component/tabs/MenuTab"
import ProdottiForm from "./ProdottiForm"
import { useSelector } from "react-redux"



const SubStrucutureProdotti = ({ Component }) => {
    const singleData = useSelector((state) => state.prodotto?.singleProdotti[0]);
    
    return (
        <>
            <div className="pageTemplate">

                <Grid container spacing={3}>
                    <Grid size={{lg:3, md:4, xs:12}}>

                        <ProdottiForm singleData={singleData}/>
                    </Grid>
                    <Grid size={{lg:9, md:8, xs:12}}>
                        <Box className="TemplateForm__right">
                            <MenuTab subStructureProdotti={true} />
                        </Box>
                        {Component && <Component />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default SubStrucutureProdotti
